import { useLocation } from '@reach/router';

import { isProductionEnvironment } from '../../../utils/env';

export const useCrossLinkFromInbox = () => {
  if (isProductionEnvironment()) {
    // on prod pathname is /deum-demo/skrzynka-intencji, on local dev it's /skrzynka-intencji
    const { pathname } = useLocation();
    const slug = pathname.split('/')[1];
    const intencjeOnlineUrl = `https://intencjeonline.pl/${slug}`;

    return intencjeOnlineUrl;
  }

  return '/massOfferings';
};
